// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._8Noy8uviuofpeLqRsbY{margin-bottom:0}.QKU0EyErJyUR1Tvrtmw7{color:var(--content-brand-primary);font-weight:500;text-decoration:none}.QKU0EyErJyUR1Tvrtmw7:hover{color:var(--content-brand-secondary);text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sessionLifetime": `_8Noy8uviuofpeLqRsbY`,
	"learnMoreLink": `QKU0EyErJyUR1Tvrtmw7`
};
export default ___CSS_LOADER_EXPORT___;
